import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";

export default function Testimonials() {
    const { data } = useContext(ContentContext);
    const list = data.testimonials;
    if (!list || !list.length) return null;

    return (
        <section className="py-20 md:py-24 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="max-w-2xl mb-10">
                    <div className="inline-flex items-center gap-3 mb-3">
                        <span className="h-px w-10 bg-gold-500" />
                        <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                            What partners say
                        </span>
                    </div>
                    <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 leading-tight">
                        Trusted by retailers, exporters and marketplaces.
                    </h2>
                </div>
                <div className="grid md:grid-cols-3 gap-6">
                    {list.map((t, i) => (
                        <figure
                            key={i}
                            className="bg-navy-50 border border-navy-100 rounded-2xl p-6 flex flex-col"
                        >
                            <div className="text-4xl font-serif text-gold-500 leading-none mb-3">"</div>
                            <blockquote className="text-navy-800 leading-relaxed text-sm flex-1">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-5 pt-4 border-t border-navy-100">
                                <div className="font-serif font-bold text-navy-900 text-sm">{t.name}</div>
                                <div className="text-xs text-navy-700/70 uppercase tracking-wider mt-0.5">
                                    {t.company}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
